import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Styles/Navbar.css';
import icon from '../images/Groomwell_icon.jpg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMobileMenu = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav
      className={isScrolled ? 'navbar scrolled' : 'navbar'}
      aria-label="Main Navigation"
    >
      {/* Logo with SEO-friendly alt text */}
      <div className="navbar-logo">
        <Link to="/" onClick={closeMobileMenu} title="Groomwell Salon Hafeezpet - Home">
          <img
            className="nav-icon"
            src={icon}
            alt="Groomwell Women's Salon - Best Salon in Hafeezpet"
            width={250}
          />
        </Link>
      </div>

      {/* Navigation Links with descriptive titles */}
      <ul className={isOpen ? 'nav-links open' : 'nav-links'}>
        <li>
          <Link
            to="/AboutPage"
            onClick={closeMobileMenu}
            title="About Groomwell Women's Salon"
          >
            ABOUT
          </Link>
        </li>
        <li>
          <Link
            to="/Services"
            onClick={closeMobileMenu}
            title="Salon Services in Hafeezpet"
          >
            SERVICES
          </Link>
        </li>
        <li>
          <Link
            to="/GalleryPage"
            onClick={closeMobileMenu}
            title="Salon Interior & Work Gallery"
          >
            GALLERY
          </Link>
        </li>
        <li>
          <Link
            to="/Contact"
            onClick={closeMobileMenu}
            title="Contact Groomwell Salon Hafeezpet"
          >
            CONTACT
          </Link>
        </li>
        <li>
          <Link
            to="/FAQ"
            onClick={closeMobileMenu}
            title="Frequently Asked Questions"
          >
            FAQ
          </Link>
        </li>
      </ul>

      {/* Hamburger Menu */}
      <button
        className={isOpen ? 'menu-icon open' : 'menu-icon'}
        onClick={toggleMenu}
        aria-label="Toggle Menu"
      >
        <div className="bar1"></div>
        <div className="bar2"></div>
        <div className="bar3"></div>
      </button>
    </nav>
  );
};

export default Navbar;
